/*
 * ygh-countdown.js — shared fixed-date countdown used across the site
 * (announcement bar, sale banner, category pages, ...).
 *
 * Usage: give any element
 *   data-ygh-countdown data-end="2026-07-05T23:59:59"
 * with child spans [data-cd-d] [data-cd-h] [data-cd-m] [data-cd-s].
 *
 * - data-end is a WALL-CLOCK time in US Eastern (America/New_York),
 *   DST-aware via Intl (falls back to UTC-5 if Intl is unavailable).
 * - Counts DOWN to the fixed end date. Never resets. At 0 it stays at
 *   00:00:00:00 and the element gets an `is-ended` class.
 * - All matching elements on the page are re-scanned every tick, so
 *   cloned markup (e.g. marquee announcement bars) stays in sync.
 */
(function () {
  if (window.__yghCountdown) return;
  window.__yghCountdown = true;

  var cache = {};

  function etToUtc(str) {
    if (!str) return NaN;
    if (cache[str] !== undefined) return cache[str];
    var m = str.trim().replace(' ', 'T').split(/[-T:]/);
    var y = +m[0], mo = +m[1] || 1, d = +m[2] || 1, h = +m[3] || 0, mi = +m[4] || 0, s = +m[5] || 0;
    if (!y) { cache[str] = NaN; return NaN; }
    var wall = Date.UTC(y, mo - 1, d, h, mi, s);
    var ts = wall + 5 * 3600 * 1000; // fallback: treat input as UTC-5
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      });
      ts = wall;
      for (var i = 0; i < 2; i++) { // converge on the UTC instant whose ET wall time matches
        var p = {};
        fmt.formatToParts(new Date(ts)).forEach(function (x) { p[x.type] = x.value; });
        var asET = Date.UTC(+p.year, +p.month - 1, +p.day, (+p.hour) % 24, +p.minute, +p.second);
        ts += wall - asET;
      }
    } catch (e) { /* keep UTC-5 fallback */ }
    cache[str] = ts;
    return ts;
  }

  function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

  function setAll(el, sel, val) {
    var nodes = el.querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== val) nodes[i].textContent = val;
    }
  }

  function tick() {
    var els = document.querySelectorAll('[data-ygh-countdown]');
    if (!els.length) return;
    var now = Date.now();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = etToUtc(el.getAttribute('data-end'));
      if (isNaN(end)) continue;
      var diff = end - now;
      var ended = diff <= 0;
      if (ended) diff = 0;
      if (el.classList.contains('is-ended') !== ended) el.classList.toggle('is-ended', ended);
      setAll(el, '[data-cd-d]', pad(Math.floor(diff / 86400000)));
      setAll(el, '[data-cd-h]', pad(Math.floor(diff % 86400000 / 3600000)));
      setAll(el, '[data-cd-m]', pad(Math.floor(diff % 3600000 / 60000)));
      setAll(el, '[data-cd-s]', pad(Math.floor(diff % 60000 / 1000)));
    }
  }

  tick();
  setInterval(tick, 1000);
})();
